<template>
    <footer class="footer pt-4 d-print-none">
        <b-container>
            <!-- <div style="text-align:center;margin-top:-50px;margin-bottom:20px;">
                <div style="height:40px;background-color:white;display:inline-block;padding:0 10px;">
                    <a href="https://www.facebook.com/roverkob.dk/"><img style="height:40px;margin:0 10px;" src="/Dist/img/footer-top-facebook.png" /></a>
                    <a href="https://www.instagram.com/roverkob/"><img style="height:40px;margin:0 10px;" src="/Dist/img/footer-top-instagram.png" /></a>
                    <a href=""><img style="height:40px;margin:0 10px 0 20px;" src="/Dist/img/footer-top-youtube.png" /></a>
                </div>
            </div> -->
            <b-row class="pt-4">
                <b-col md="10" offset-md="1" lg="8" offset-lg="2">
                    <b-row>
                        <b-col cols="4" class="mb-3 text-center" v-html="column1" />
                        <b-col cols="4" class="mb-3 text-center" v-html="column2" />
                        <b-col cols="4" class="mb-3 text-center" v-html="column3" />
                    </b-row>
                    <div class="text-center mb-3" v-html="column4" />
                </b-col>
                <!-- <b-col cols="6" sm="6" md="3" lg="3" class="mb-3" v-html="column1" />
                <b-col cols="6" sm="6" md="3" lg="3" class="mb-3" v-html="column2" />
                <b-col cols="6" sm="6" md="3" lg="3" class="mb-3" v-html="column3" />
                <b-col cols="6" sm="6" md="3" lg="3" class="mb-3" v-html="column4" /> -->
            </b-row>
            <br />
            <div>
                <div class="text-center bottom">
                    <span>Skovgaard Vine ApS</span>
                    <span>Agenavej 39 - 2670 Greve</span>
                    <span>+45 70 22 66 19</span>
                    <!-- <br class="d-xl-none" />
                    <span>Alle priser er i DKK inkl. moms</span>
                    <span>Følgende betalingskort kan benyttes:</span>
                    <img src="/Dist/img/footer-betalingskort.png" /> -->
                </div>
            </div>
        </b-container>
    </footer>
</template>

<script>
import "../../icons/_rk/facebook";
import "../../icons/_rk/instagram";
import "../../icons/_rk/video";
export default {
    computed:{
        column1(){
            return window["siteData"]["FooterColumn1"];
        },
        column2(){
            return window["siteData"]["FooterColumn2"];
        },
        column3(){
            return window["siteData"]["FooterColumn3"];
        },
        column4(){
            return window["siteData"]["FooterColumn4"];
        },
    }
};
</script>

<style lang="scss">
@import "node_modules/bootstrap/scss/functions";
@import "node_modules/bootstrap/scss/variables";
@import "node_modules/bootstrap/scss/mixins";
@import "../colors";

    .footer{
        color: white !important;
        background-color: $dark;
        line-height:20px;
        display: block;
        padding-bottom:0.25rem;
        // /deep/ a{
        //     // color:$white;
        // }
        a{
            color:$white;
        }
        h3{
            font-size: 0.96rem;
            font-weight: bold;
            margin-bottom:0;
        }
    }
    .bottom{
        font-size:12px;
        span, img{
            display:inline-block;
            margin:2px 12px;
        }
    }
    
</style>
